






























import { VisitHistoryInformation } from "../../../domain/his";
import { Component, Mixins, Prop, Emit, Watch } from "vue-property-decorator";
import { ElTable, SortOrder } from "element-ui/types/table";
import { TableColumn } from "element-ui/types/table-column";
import { ISortParameter } from "../../system";
import { Comparator } from "../../../domain/system";

interface IHistoryColumn {
  toValue: ToValueType;
}

type ToValueType = (s: VisitHistoryInformation) => number | boolean | string | Date;

@Component
export default class VisitHistorySelector extends Mixins() {
  @Prop()
  histories: VisitHistoryInformation[];
  
  tableData: VisitHistoryInformation[] = [];
  defaultSort: ISortParameter = {
    property: "visitDate",
    order: "descending",
  };

  private static readonly _columns: { [key: string]: IHistoryColumn; } = {
    visitDate: { toValue: s => s.visitDateText ? s.visitDateText : "" },
    department: { toValue: s => s.department ? s.department.name : "" },
    doctor: { toValue: s => s.doctor ? s.doctor.name : "" },
  };

  data(): any {
    return {
      sortParameter: null,
    };
  }
  sortParameter: ISortParameter;

  $refs!: {
    table: ElTable,
  };

  mounted() {
    this.tableData = this.histories;
    this.sortParameter = this.defaultSort;
  }

  toDate(row: VisitHistoryInformation): string {
    if (!row.visitDate) { return ""; }
    return this.toDateString(row.visitDate);
  }

  toDepartmentName(row: VisitHistoryInformation): string {
    return row.department ? row.department.name : "";
  }

  toDoctorName(row: VisitHistoryInformation): string {
    return row.doctor ? row.doctor.name : "";
  }

  onSortChanged(param: { column: TableColumn, prop: string, order: SortOrder }): void {
    this.sortParameter = {
      property: param.prop,
      order: param.order ? param.order : "ascending",
    };
  }

  updateSort(): void {
    if (this.$refs.table && this.sortParameter) {
      this.$refs.table.sort(this.sortParameter.property, this.sortParameter.order);
      this.tableData.sort((a, b): number => {
        const toValue = VisitHistorySelector._columns[this.sortParameter.property].toValue;
        return Comparator.compare(toValue(a), toValue(b), this.sortParameter.order === "ascending");
      });
    }
  }

  clearSelected(): void {
    if (!this.$refs.table) { return; }
    // setCurrentRow()で選択行がリセットされないため、代替としてdataの入れ直しで対応する
    this.tableData = [];
    this.$nextTick(() => this.tableData = this.histories);
  }

  private toDateString(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1);
    const day = String(date.getDate());
    return year.toString() + " / " + month + " / " + day;
  }

  @Watch("sortParameter")
  onSortParameterUpdated(newValue: ISortParameter, oldValue: ISortParameter): void {
    if (!oldValue || (newValue.property !== oldValue.property || newValue.order !== oldValue.order)) {
      this.updateSort();
    }
  }

  @Watch("histories")
  onHistoriesChanged(newValue: VisitHistoryInformation[], oldValue: VisitHistoryInformation[]): void {
    if (newValue === oldValue) { return; }
    this.tableData = this.histories;
    this.sortParameter = this.defaultSort;
  }

  @Emit()
  historySelectionChanged(history: VisitHistoryInformation): void {}
}
